import store from '../store'
import { isEmpty } from '@/common/utils'

export const DATA_KEY_USER = 'current_user'
export const DATA_KEY_USER_AND_OFFER = 'current_user_and_offer'
export const DATA_KEY_USER_CARDS = 'current_user_cards'
export const DATA_KEY_INITIAL_VALIDATION = 'initial_validation'

/**
 * store current user data
 * @param {Object} data
 */
const storeUserData = data => store.set(DATA_KEY_USER, data)

/**
 * store current user and offer migration action
 * @param {AcaoPermitidaParaPlanoEscolhidoEnum} action
 */
const storeUserAndPlanSituation = action => store.set(DATA_KEY_USER_AND_OFFER, action)

const storeUserCards = cards => store.set(DATA_KEY_USER_CARDS, cards)

const storeUserInitialValidation = data => store.set(DATA_KEY_INITIAL_VALIDATION, data)

/**
 * load current user data
 * @returns {Promise<Object>}
 */
const loadUserData = async () => {
  const data = await store.get(DATA_KEY_USER)

  if (isEmpty(data)) {
    return Promise.reject(new Error('Não há dados do usuário'))
  }

  if (isEmpty(data.cpf) || isEmpty(data.msisdn)) {
    const err = new Error('Dados incompletos')
    err.metaData = { data }
    return Promise.reject(err)
  }

  return Promise.resolve(data)
}

/**
 * load current user and plan migration action data
 * @returns {Promise<AcaoPermitidaParaPlanoEscolhidoEnum>}
 */
const loadUserAndPlanSituation = async () => await store.get(DATA_KEY_USER_AND_OFFER)

const loadUserCards = async () => await store.get(DATA_KEY_USER_CARDS)

const loadUserInitialValidation = async () => await store.get(DATA_KEY_INITIAL_VALIDATION)

export {
  storeUserData,
  loadUserData,
  storeUserAndPlanSituation,
  loadUserAndPlanSituation,
  loadUserCards,
  storeUserCards,
  storeUserInitialValidation,
  loadUserInitialValidation
}
